import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
const BaseModalBackground = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: ${(props) => (!props.isOpen ? 0 : 1)};
  background-color: rgba(0, 0, 0, 0.63);
  align-items: center;
  justify-content: center;
  animation: ${(props) =>
    css`
      ${fadeIn} ${props.delay}ms ease-out;
    `};
  transition: ${(props) => `opacity ease-in ${props.delay}ms`};
`;

export default BaseModalBackground;
